import axios from 'axios';
import { getSession, removeSession } from 'core/api/session';
import { AuthService } from 'core/api/services/auth';
import { toast } from 'react-toastify';

const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 60000,
});

export const Method = {
  GET: 'GET',
  PUT: 'PUT',
  PATCH: 'PATCH',
  POST: 'POST',
  DELETE: 'DELETE',
};

// TODO: implement refresh token interceptor
export const fetch = async (url, config) => {
  const { authenticated = false, ...options } = config;

  const request = {
    ...options,
    headers: {
      'Content-Type': 'application/json',
    },
    url,
  };
  try {

    if (authenticated) {
      let token = getSession();
      if (!token || token == null) {
        token = await AuthService.getToken();
      }
      request.headers.Authorization = `Bearer ${token}`;
    }

    const response = await httpClient.request(request);

    if(response?.data?.errors?.length) {
      const errors = response?.data?.errors;
      for (let i = 0; i < errors.length; i++) {
        const element = errors[i]; 
        toast.error(`Code: ${element.code}
        Msg ${element.msg}`, {
          position: 'top-right',
          theme: 'colored',
        });
      }
    }

    return response.data;
  } catch (error) {

    // 401/403 here, clean session and redirect
    /* This is kind of brute force but it works.. the better way to implement this is to have a refresh token and a request interceptor for axios on the FrontEnd
    forces window to reload, and as all auth info is erased, will prompt you to Login again thanks to RedirectRoute wrapper on the Routing index
    */
    // The apiserver now splits the two: 401 = "who are you?" (missing/expired/invalid token),
    // 403 = "you are not allowed". Only 403 was handled here, so once the admin routes started
    // answering 401 for an expired token the request just failed silently and the UI hung instead
    // of bouncing to the Google login. Both mean "this session is no good" for utools, which has no
    // refresh flow, so treat them the same.
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      console.log(`Gotten Status ${error.response.status}...`);
      removeSession();
      console.log('Removed session token...');
      document.location.reload();
    }
    throw error;
  }
};

export const getPaging = (options={}) => {
  if (!options.pager) {
    return "";
  }

  let order = ""
  if(options.pager.column) {
    order += `&column=${options.pager.column}`
    if(options.pager.direction) {
      order += `&direction=${options.pager.direction}`
    }
  }
  return `page=${parseInt(options.pager.page)|| 1}&pageSize=${parseInt(options.pager.pageSize)|| 30}${order}`;
};